__turbopack_context__.v({
  "btn": "ScholorshipJourneyNew-module-scss-module__95qBjW__btn",
  "inner": "ScholorshipJourneyNew-module-scss-module__95qBjW__inner",
  "mobileImg": "ScholorshipJourneyNew-module-scss-module__95qBjW__mobileImg",
  "section": "ScholorshipJourneyNew-module-scss-module__95qBjW__section",
  "subtitle": "ScholorshipJourneyNew-module-scss-module__95qBjW__subtitle",
  "textGroup": "ScholorshipJourneyNew-module-scss-module__95qBjW__textGroup",
  "title": "ScholorshipJourneyNew-module-scss-module__95qBjW__title",
  "titleHighlight": "ScholorshipJourneyNew-module-scss-module__95qBjW__titleHighlight",
});
